const StatusNote = ({ children }) => (
  <div className="status-note">{children}</div>
);

export default StatusNote;
